module.exports = __webpack_public_path__ + "static/media/add-client.567c1050.png";